<template>
  <div id="all">
    <div id="page-flip" :class="animationClass" class="goal-book">
      <div id="r1">
        <div id="p1">
          <!-- <div v-if="getTurnedPage.new === 0" class="columns is-multiline">
            <div class="column is-12 flex-center">
              <h2>{{$t('goals.bookFrontLabel')}}</h2>
            </div>
            <div class="column is-12 goal-book-paragraph">
              <p>{{$t('goals.bookFrontParagraph')}}</p>
            </div>
          </div> -->

          <div class="columns is-multiline">
            <div class="column is-12 flex-center">
              <h2 v-if="getTurnedPage.old !== 0">{{getGoalList[getTurnedPage.old - 1].code}}: {{getGoalList[getTurnedPage.old - 1].title}}</h2>
              <div v-else class="goal-book-sdg-wheel">
                <!-- <icon class="tiny-svg flex-align-center" name="sdg-wheel"></icon> -->
                <icon class="small-svg flex-align-center flex" name="un"></icon>
                <h2>{{$t('goals.bookFrontLabel')}}</h2>
              </div>
            </div>
            <div v-if="getTurnedPage.old !== 0" class="column is-12 goal-book-paragraph" v-html="getGoalList[getTurnedPage.old - 1].description"></div>
            <div v-else class="column is-12 goal-book-paragraph">{{$t('goals.bookFrontParagraph')}}</div>
          </div>

        </div>
      </div>
      <div id="r2">
        <div id="p2">
          <div class="goal-book-border-right"></div>
          <div class="columns is-multiline goal-book-container" ref="goalBook">
            <div class="column is-12 goal-book-header">
              <icon v-if="getTurnedPage.new" class="medium-svg sdg-target-icons flex" :class="['goal-color-' + getTurnedPage.new]" :name="getTurnedPage.new" :language="getLanguage"></icon>
              <h3 v-if="getTurnedPage.new !== 0">{{getGoalList[getTurnedPage.new - 1].code}}: {{getGoalList[getTurnedPage.new - 1].title}}</h3>
              <div v-else class="goal-book-sdg-wheel">
                <icon class="medium-svg flex-align-center flex" name="un"></icon>
                <!-- <icon class="tiny-svg flex-align-center flex" name="sdg-wheel"></icon> -->
                <h2>{{$t('goals.bookFrontLabel')}}</h2>
              </div>
            </div>
            <div v-if="getTurnedPage.new !== 0" class="column is-12 goal-book-paragraph" :style="{overflow: overflow}" v-on:scroll="handleScroll" ref="goalBookParagraph" v-html="getGoalList[getTurnedPage.new - 1].description">
            </div>
            <div v-else class="column is-12 goal-book-paragraph">{{$t('goals.bookFrontParagraph')}}</div>
            <transition name="fade-quick">
              <button class="button scroll-button-up" ref="scrollUp" v-if="getTurnedPage.new !== 0 && scrollUpVisible" @click="scroll('up')">
                <icon class="tiny-svg fill-gray" name="arrow-up"></icon>
              </button>
            </transition>
            <transition name="fade-quick">
              <button class="button scroll-button-down" ref="scrollDown" v-if="getTurnedPage.new !== 0 && scrollDownVisible" @click="scroll('down')">
                <icon class="tiny-svg fill-gray flex" name="arrow-down"></icon>
              </button>
            </transition>
            <div class="goal-book-fade-top" v-if="getTurnedPage.new !== 0 && scrollUpVisible"></div>
            <div class="goal-book-fade-bottom" v-if="getTurnedPage.new !== 0 && scrollDownVisible"></div>
          </div>
        </div>
      </div>

      <div id="r3">
        <div id="p3">
          <div>
            <div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ødelægger z-index, når man vil scrolle -->
      <!-- <div id="rn">
        <div id="pn">
          <div>
            <div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Har du brug for dem? -->
      <!-- <div class="s">
        <div id="s3">
          <div id="sp3">
          </div>
        </div>
      </div>
      <div class="s" id="s4"><div id="s2"><div id="sp2"></div></div></div> -->
    </div>
    <div class="post-it">
      <li @click="validatePage(0)" class="book-mark-frontpage" :class="{'selected-bookmark': getTurnedPage.new === 0}">
        <!-- <icon class="tiny-svg" name="sdg-wheel"></icon> -->
        <icon class="tiny-svg" name="un"></icon>
      </li>
      <li v-for="goal in getGoalList" class="goal-post-it" :key="Number(goal.code)" @click="validatePage(goal.code)" :class="['goal-color-' + Number(goal.code), {'selected-bookmark': Number(goal.code) === getTurnedPage.new}]">
        {{goal.code}}
      </li>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'goal-book',
  data () {
    return {
      animationClass: null,
      scrollUpVisible: false,
      scrollDownVisible: true,
      overflow: 'auto'
    }
  },
  computed: {
    ...mapGetters({
      getProject: 'getProject',
      getTurnedPage: 'getTurnedPage',
      getBookGoal: 'getBookGoal',
      getGoalList: 'getGoalList',
      getLanguage: 'getLanguage'
    })
  },
  watch: {
    getBookGoal () {
      this.validatePage(this.getBookGoal)
    }
  },
  methods: {
    ...mapActions({
      setTurnedPage: 'setTurnedPage'
    }),
    validatePage (page) {
      if (this.$refs.goalBookParagraph) {
        this.$refs.goalBookParagraph.scrollTop = 0
      }
      new Promise((resolve, reject) => {
        resolve(this.setTurnedPage(page))
      }).then(() => {
        if (Number(this.getTurnedPage.old) !== Number(this.getTurnedPage.new)) {
          this.animationClass = 'pageTurn'
          this.overflow = 'hidden'
          setTimeout(() => {
            this.animationClass = 'hidden'
            this.overflow = 'auto'
          }, 800)
        }
      })
    },
    scroll (direction) {
      let scroll = this.$refs.goalBookParagraph.scrollTop

      if (direction === 'down') {
        scroll += 200
      } else {
        scroll -= 200
      }

      this.$refs.goalBookParagraph.scrollTop = scroll
      this.scrollDownVisible = scroll + this.$refs.goalBookParagraph.clientHeight < this.$refs.goalBookParagraph.scrollHeight
      this.scrollUpVisible = scroll > 0
    },
    handleScroll () {
      this.scrollDownVisible = this.$refs.goalBookParagraph.scrollTop + this.$refs.goalBookParagraph.clientHeight < this.$refs.goalBookParagraph.scrollHeight
      this.scrollUpVisible = this.$refs.goalBookParagraph.scrollTop > 0
    }
  }
}
</script>
